(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/ticket-sunfeather.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/ticket-sunfeather.js');
"use strict";


const {
  useState,
  useCallback,
  Fragment
} = React;
setGlobal('svs.tickets.play.components.TicketSunfeather', _ref => {
  let {
    accessibleText,
    children,
    onHandleNumberChanged,
    handleGamePay
  } = _ref;
  const [hoverTicketNumber, setHoverTicketNumber] = useState(-1);
  const [activeFocus, setActiveFocus] = useState(null);
  const onMouseLeave = useCallback(() => {
    setHoverTicketNumber(-1);
  }, []);
  const onBlur = useCallback(() => setActiveFocus(null), []);
  const getHoverState = useCallback(number => {
    switch (number - hoverTicketNumber) {
      case -1:
        return -1;
      case 1:
        return 1;
      case 0:
        return 0;
      default:
        return undefined;
    }
  }, [hoverTicketNumber]);
  return React.createElement("div", {
    className: "sunfeather-container",
    "data-testid": "sunfeather-container"
  }, React.createElement("div", {
    className: "sunfeather-inner-container relative"
  }, React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
      handleGamePay();
    }
  }, React.createElement("fieldset", null, React.createElement("legend", {
    className: "ticket-sunfeather-legend"
  }, accessibleText), React.Children.map(children, child => {
    const {
      number,
      chosen
    } = child.props;
    const onChange = useCallback(() => onHandleNumberChanged(number), [number]);
    const onFocus = useCallback(() => setActiveFocus(number), [number]);
    return React.createElement(Fragment, null, React.createElement("input", {
      "aria-label": "Lott ".concat(number, " av ").concat(children.length),
      checked: chosen,
      className: "qa-ticket-sunfeather-radio hide-radio absolute",
      "data-testid": "ticket-sunfeather-radio-".concat(number),
      name: "ticket-skin-radio",
      onBlur: onBlur,
      onChange: onChange,
      onFocus: onFocus,
      type: "radio",
      value: number
    }), React.createElement("label", {
      className: "sunfeather-item-wrapper"
    }, React.cloneElement(child, {
      onMouseEnter: setHoverTicketNumber,
      onMouseLeave,
      hoverState: getHoverState(number),
      hasFocus: activeFocus === number
    })));
  })), React.createElement("input", {
    className: "qa-ticket-sunfeather-input",
    name: "submit-button",
    style: {
      opacity: 0,
      width: 0,
      height: 0
    },
    tabIndex: "-1",
    type: "submit"
  }), React.createElement("div", {
    className: "sunfeather-height-wrapper"
  }, children[0]))));
});

 })(window);